// var configEnv = "development";
// var configEnv = "staging";
// var configEnv = "production";

var configEnv = process.env.REACT_APP_NODE_ENV;
if (!["development", "staging", "production"].includes(configEnv)) {
  throw new Error(`Invalid REACT_APP_NODE_ENV value: ${configEnv}`);
}

var config = {
  //##########Live config##########
  production: {
    appUrl: "https://geniejackpot.com",
    apiUrl: "https://api.geniejackpot.com/api/v1",
    staticUrl: "https://api.geniejackpot.com/api/v1",
    liveChatUrl: "https://tawk.to/chat/65f4839f8d261e1b5f6e04ab/1hp1i49pj",
    fileSourceUrl: "https://headoffice54.geniejackpot.com/public",
    debug: false,
    payOpPublicKey: "application-c7618853-5305-43b1-9bee-416d584f039c",
    FBAppId: "924177942783152",
    GoogleClientId: "10707350668-3ahomquo0qik7bmb5l3b64od3397qqqi.apps.googleusercontent.com",
    discordClientId: "1227177703304728586",
  },

  //#########Stage config##########
  staging: {
    appUrl: "https://geniejackpot.cbstagings.com",
    apiUrl: "https://geniejackpotapi.cbstagings.com/api/v1",
    staticUrl: "https://geniejackpotapi.cbstagings.com/api/v1",
    liveChatUrl: "https://geniejackpotboss.cbstagings.com/public/livechat/php/app.php?widget-inline",
    fileSourceUrl: "https://geniejackpotboss.cbstagings.com/public",
    debug: false,
    payOpPublicKey: "",
  },

  // staging: {
  //   appUrl: "https://gj.chimptestserver.com",
  //   apiUrl: "https://2casinoapi.chimptestserver.com/api/v1",
  //   staticUrl: "https://2casinoapi.chimptestserver.com/api/v1",
  //   liveChatUrl:
  //     "https://2casinobossoffice.chimptestserver.com/public/livechat/php/app.php?widget-inline",
  //   fileSourceUrl: "https://2casinobossoffice.chimptestserver.com/public",
  //   debug: false,
  //   payOpPublicKey: "",
  // },

  //##########Local config##########
  development: {
    appUrl: "http://front.casino.local:3000",
    apiUrl: "http://api.casino.local:8002/api/v1",
    staticUrl: "http://api.casino.local:8002/api/v1",
    liveChatUrl: "http://livechat.casino.local:8003/php/app.php?widget-inline",
    fileSourceUrl: "http://admin.casino.local:8001/public",
    debug: true,
    payOpPublicKey: "",
    FBAppId: "231883126343445",
    GoogleClientId: "360167865977-r5tlc2945otjdnrkndepva1q3qaom4tq.apps.googleusercontent.com",
  },
};

var finalConfig = config[configEnv];

finalConfig.defaultLanguage = {
  code: "en",
  language: "English",
  flag_path: finalConfig.fileSourceUrl + "/images/flags/svg/gb.svg",
};

export default finalConfig;
